import { Navigate } from "react-router";

export const BankanRedirect = () => {
  return <Navigate to="InformationReview" />;
};
